<div id="js-password-hints">
	<h4>{{TR "Passwortkriterien"}}</h4>
	<div>
		<span>{{TR "Länge"}}</span>
		{{#if length}}
			<i class="glyphicon glyphicon-ok text-success"></i>
		{{/if}}
	</div>
	<div>
		<span>{{TR "Zahlen"}}</span>
		{{#if number}}
			<i class="glyphicon glyphicon-ok text-success"></i>
		{{/if}}
	</div>
	<div>
		<span> {{TR "Groß- und Kleinschreibung"}} </span>
		{{#if cases}}
			<i class="glyphicon glyphicon-ok text-success"></i>
		{{/if}}
	</div>
	<div>
		<span>{{TR "Sonderzeichen"}}</span>
		{{#if specialChar}}
			<i class="glyphicon glyphicon-ok text-success"></i>
		{{/if}}
	</div>

	<h4>{{TR "Hinweise"}}</h4>
	<div>
		<i class="glyphicon glyphicon-remove"></i>
		<span>{{TR "Keine persönlichen Daten."}}</span>
	</div>
	<div>
		<i class="glyphicon glyphicon-remove"></i>
		<span>{{TR "Keine trivialen Passwörter."}}</span>
	</div>
</div>
